import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import {
  Compass,
  Flame,
  Heart,
  LayoutGrid,
  ListChecks,
  MessagesSquare,
  BookOpen,
  Package,
  Sparkles,
  Store,
} from "lucide-react";
import { cn } from "@/lib/utils";
import { useT } from "@/i18n";

export const Route = createFileRoute("/marketplace")({
  component: MarketplaceLayout,
});

const MP_MENU = [
  { to: "/marketplace", key: "mp.nav.home", icon: Store, exact: true },
  { to: "/marketplace/explore", key: "mp.nav.explore", icon: Compass },
  { to: "/marketplace/categories", key: "mp.nav.categories", icon: LayoutGrid },
  { to: "/marketplace/hot", key: "mp.nav.hot", icon: Flame, hot: true },
  { to: "/marketplace/requests", key: "mp.nav.requests", icon: MessagesSquare },
  { to: "/marketplace/offers", key: "mp.nav.offers", icon: Sparkles },
  { to: "/marketplace/favorites", key: "mp.nav.saved", icon: Heart },
  { to: "/marketplace/orders", key: "mp.nav.orders", icon: ListChecks },
  { to: "/marketplace/sell", key: "mp.nav.sell", icon: Package },
  { to: "/marketplace/guides", key: "mp.nav.guides", icon: BookOpen },
] as const;

function MarketplaceLayout() {
  const { t } = useT();
  return (
    <>
      <div className="sticky top-20 z-30 border-b border-border bg-background/95 shadow-sm backdrop-blur">
        <nav
          aria-label={t("mp.nav.aria_label")}
          className="mx-auto flex max-w-6xl items-center gap-1 overflow-x-auto px-4 py-2 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        >
          {MP_MENU.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              activeOptions={{ exact: "exact" in item }}
              activeProps={{
                className: cn(
                  "bg-primary text-primary-foreground shadow-sm hover:bg-primary hover:text-primary-foreground",
                ),
              }}
              className={cn(
                "flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-3.5 py-2 text-sm font-semibold text-muted-foreground transition-colors hover:bg-muted hover:text-foreground",
              )}
            >
              <item.icon className="size-4" />
              {t(item.key)}
            </Link>
          ))}
        </nav>
      </div>
      <Outlet />
    </>
  );
}
